import React, { useState } from "react";

import "./forgot_password.css";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import LockResetIcon from "@mui/icons-material/LockReset";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import KeyIcon from "@mui/icons-material/Key";
import HelpIcon from "@mui/icons-material/Help";
import { IconButton } from "@mui/material";
import logo from "../../images/PPKM_Head.png";
import getEventController from "../Member/Controller/getEvent_controller";

const PasswordAuthentication = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, userID, companyName, memberId } = location.state; // Access passed data
  console.log(email);
  console.log(userID);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showRetypePassword, setShowRetypePassword] = useState(false);
  const [RetypePassword, setRetypePassword] = useState("");
  const [showNewPin, setShowNewPin] = useState(false);
  const [NewPin, setNewPin] = useState("");
  const [showRetypeNewPin, setShowRetypeNewPin] = useState(false);
  const [RetypeNewPin, setRetypeNewPin] = useState("");
  const [error, setError] = useState(null);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const toggleRetypePasswordVisibility = () => {
    setShowRetypePassword((prev) => !prev);
  };
  const toggleNewPinVisibility = () => {
    setShowNewPin((prev) => !prev);
  };
  const toggleRetypeNewPinVisibility = () => {
    setShowRetypeNewPin((prev) => !prev);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError(null);

    if (password !== RetypePassword || NewPin !== RetypeNewPin) {
      setError("New passwords or PINs do not match.");
      return;
    }

    // console.log(password);
    // console.log(NewPin);

    const response = await getEventController.UpdatePasswordAndPin(
      userID,
      password,
      NewPin
    );

    if (response) {
      alert("Password and Pin Updated Successfully.");
      navigate("/dashboard");
    } else {
      setError("Reset Failed. Please try again.");
    }
  };

  return (
    <div className="set-password-page">
      <div className="d-flex set-password-container">
        <div className="set-password-wrapper">
          <div className="login-title">
            <img className="sp-web-login-logo" src={logo} alt="Logo" />
          </div>
          <p className="pa-title_para">PASSWORD SETUP</p>
          {/* <p className="re-span">
            You've selected to login.
            <br /> Kindly enter the correct password to login.
          </p> */}
          <div className="mt-2">
            <label className="form-label pa-form-label">
              Password Setup For
            </label>
            <div className="account-info-block">
              <span className="account-info-lbl">Neudimenxion</span>
              <span className="account-info-lbl2">Membership No.: M-0001</span>
            </div>
          </div>
          <div>
            <label className="form-label sp-alert-lbl">
              Password must be at least 8 characters long with mix alphabets,
              numbers, capital, and small letters.
            </label>
          </div>
          <form className="set-password-form">
            {/* New Password */}
            <div className="password-row">
              <label className="form-label sp-lbl">
                New Password <HelpIcon className="sp-info-icon" />
              </label>
              <div className="pa-row">
                {/* password */}
                <LockIcon className="sp-form-logo" />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="New Password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <IconButton
                  onClick={togglePasswordVisibility}
                  sx={{
                    padding: 0,
                  }}
                >
                  {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </div>
            </div>
            {/* New Retype Password */}
            <div className="password-row">
              <label className="form-label sp-lbl">Retype Password</label>
              <div className="pa-row">
                {/* password */}
                <LockIcon className="sp-form-logo" />
                <input
                  type={showRetypePassword ? "text" : "password"}
                  placeholder="Retype Password"
                  required
                  value={RetypePassword}
                  onChange={(e) => setRetypePassword(e.target.value)}
                />
                <IconButton
                  onClick={toggleRetypePasswordVisibility}
                  sx={{
                    padding: 0,
                  }}
                >
                  {showRetypePassword ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </IconButton>
              </div>
            </div>
            {/* New Pin */}
            <div className="password-row">
              <label className="form-label sp-lbl">
                New 6-Digits Pin <HelpIcon className="sp-info-icon" />
              </label>
              <div className="pa-row">
                {/* password */}
                <KeyIcon className="sp-form-logo" />
                <input
                  type={showNewPin ? "text" : "password"}
                  placeholder="New Pin"
                  required
                  value={NewPin}
                  onChange={(e) => {
                    // Restrict input to numbers and limit length to 6
                    const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
                    if (numericValue.length <= 6) {
                      setNewPin(numericValue);
                    }
                  }}
                />
                <IconButton
                  onClick={toggleNewPinVisibility}
                  sx={{
                    padding: 0,
                  }}
                >
                  {showNewPin ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </div>
            </div>
            {/* New Retype Pin */}
            <div className="password-row">
              <label className="form-label sp-lbl">Retype 6-Digits Pin</label>
              <div className="pa-row">
                {/* password */}
                <KeyIcon className="sp-form-logo" />
                <input
                  type={showRetypeNewPin ? "text" : "password"}
                  placeholder="Retype Pin"
                  required
                  value={RetypeNewPin}
                  onChange={(e) => {
                    // Restrict input to numbers and limit length to 6
                    const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
                    if (numericValue.length <= 6) {
                      setRetypeNewPin(numericValue);
                    }
                  }}
                />
                <IconButton
                  onClick={toggleRetypeNewPinVisibility}
                  sx={{
                    padding: 0,
                  }}
                >
                  {showRetypeNewPin ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </IconButton>
              </div>
            </div>
            <div className="reset-button-row">
              <Button className="reset-button" onClick={handleResetPassword}>
                Reset
              </Button>
            </div>
            <div className="sp-back-button-row">
              <a
                className="sp-back-button"
                onClick={() =>
                  navigate("/password_authentication", {
                    state: { email, userID, companyName, memberId },
                  })
                }
              >
                Back
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PasswordAuthentication;
